<template>
    <fragment>
        <div class="attachment_wrap">
            <div :id="uploadId"></div>
        </div>
        <!-- <div class="btn_wrap_full"> -->
        <div v-if="!buttonDisable" class="btn_wrap pt-10">
            <div class="btn_right">
                <a href="javascript:" type="button" class="btn_sm_white" v-if="!toolManager" @click="openFileDialog()">{{$t('BUTTON.GLOBAL.PC')}}</a>
                <a href="javascript:" type="button" class="btn_sm_white" v-if="!toolManager" @click="removeSelectedFiles()">{{$t('BUTTON.GLOBAL.DELETE.SELECTED')}}</a>
                <a href="javascript:" type="button" class="btn_sm_white" @click="removeAllFiles()">{{
                    $t('BUTTON.GLOBAL.DELETEALL')
                }}</a>
            </div>
        </div>
    </fragment>
</template>

<script>
import Vue                          from 'vue';
import { mapActions, mapGetters }   from 'vuex';
import qs                           from 'query-string';
import _                            from 'lodash';
import $                            from 'jquery';
import axios                        from 'axios';
import store                        from '@/vuex/store';
import SDLLocale                    from '@/mixin/SDLLocale';
import { SDLUtil }                  from '@/utils';

import { EventBus }                 from '@/utils/EventBus';

let urlBase     = `${SDLUtil.WEB_CONTEXT_PATH}/static/js/innorix/exam/`;    // location.href.substring(0, location.href.lastIndexOf("/") + 1);
let downApiBase = `${SDLUtil.API_URL}/basis/common/attachDownload.skp`;     // SKP Download url
let downApiSCMS = `${SDLUtil.API_URL}/noauth/common/attachDownload.skp`;    // SCMS Download url
//let upApiBase   = `${SDLUtil.API_URL}/basis/common/innorixUpload.skp`;      // SKP Upload url
let removeApi   = `${SDLUtil.API_URL}/basis/common/attachRemove.skp`;       // SKP Remove url
// oci 운영반영할때 반드시 https 로 호출할 것.
let upApiBase   = `https://skpupload.samsungcsportal.com/basis/common/innorixUpload.skp`;      // SKP Upload url
// oci 개발일 경우
//let upApiBase   = `https://skpupload.samsungcsportal.com:8888/basis/common/innorixUpload.skp`;      // SKP Upload url
const INNORIX_RESET_FILE_LIST = 'innorix-reset-file-list';
        
export default {
    name: 'InnorixUpload',
    props: {
        uploadId        : { required: true, type : String, default : 'fileControl' },
        serviceType     : { default: 'common' },
        attachList      : { default: [] },
        onlyUpload      : { default: true },
        buttonDisable   : { default: false },
        isSCMSDirect    : { default: false },
        imageCloud      : { default: false },
        toolManager     : { type : String, default : '' },
    },
    data() {
        return {
            window        : { width: 0, height: 0 },
            transferMode  : this.onlyUpload ? 'upload' : 'both',
            isLoading     : false,
            innoJquery    : new Object(), // innorix jQuery 객체선언
            control       : new Object(), // 파일전송 컨트롤 객체선언
            downFileArr   : new Array(),  // 다운로드 목록 정보
            resetFileArr  : new Array(),  // 다운로드 목록 초기화 정보
            delFileArr    : new Array(),  // 삭제된 파일 정보
            removeFlag    : true          // 삭제 이벤트 조건 플래그
        }
    },
    computed: {
        ...mapGetters({
            locale: 'getLocale',
            sessionId: 'getSessionId',
            token: 'getToken'
        }),
        getAllFiles() {
            return this.control.getAllFiles();
        }
    },

    created() {
        this.$log.info('＃ InnorixUpload.vue created');

        window.addEventListener('resize', this.handleInnorixResize);

        EventBus.$on(INNORIX_RESET_FILE_LIST, (item) => {
            if (item.uploadId === this.uploadId) {
                this.$log.info(INNORIX_RESET_FILE_LIST + ' MATCHED', item.uploadId);
                this.reloadFileList(item.fileList);

            } else {
                this.$log.info(INNORIX_RESET_FILE_LIST + ' NOT MATCHED', item.uploadId);
            }
        });
    },

    mounted() {
        this.$nextTick(() => {
            SDLUtil.importJS(`${this.$CONTEXT}/static/js/innorix/innorix.js`)
                .then(() => {
                    this.loadComplete(this.uploadId);
                    this.handleInnorixResize();
                })
                .catch(err => {
                    this.$log.error(err);
                });
            }
        );
    },

    beforeDestroy() {
        EventBus.$off(INNORIX_RESET_FILE_LIST);

    },
    destroyed() {
        window.removeEventListener('resize', this.handleInnorixResize);
    },
    methods: {
        handleInnorixResize() {
            let wrap = document.getElementsByClassName('attachment_wrap')[0];
            this.window.width = wrap.clientWidth - 25;
            this.window.height = wrap.clientHeight - 25;
            this.setSize(this.window.width, 200);

            $(".irx-file-inner-wrapper .btn-group").detach();

        },
        setSize(width, height) {
            if(this.isLoading) this.control.setSize(width, height);
        },
        loadComplete(uploadId) {
            this.$log.info('＃ InnorixUpload.vue call loadComplete. Transfer Mode is ', this.transferMode);
            //this.$log.info('＃ utest ', utest);
            //this.$log.info('＃ WEB_CONTEXT_PATH ', SDLUtil.WEB_CONTEXT_PATH);
            this.$log.info('＃ upApiBase ', upApiBase);
            this.innoJquery = innorix._load("innoJquery");
            let initCreateObject = {
                el: '#' + uploadId,
                transferMode: this.transferMode,
                integrity: 'block',/*none : 무결성 검증 안함, 기본값
					                block : 조각에 대한 무결성 검증
					                file : 파일에 대한 무결성 검증
					                both : 조각 및 파일에 대한 무결성 검증
					                */
             	// true = Agent 설치, false = html5 모드 사용
                agent: true,
                // showGraph: true,
                useContextMenu: false,
                showFileListHeader: false,
                useDownloadAction: false,
                progressTitle: 'SKP',
                loadTranfer: false, //업로드컨트롤에서 미완료에 대한 이어전송 alert 출력 여부
                resumeDownloadType: 'numbering', // 중복파일처리정책 자동번호붙여 저장 | overwrite, relay, numbering, confirm
                resumeUploadType: 'overwirte', // 업로드이어전송 정책 | overwirte, relay,
                // uploadSliceSize: 2097152, // 2MB
                uploadSliceSize: 10485760, // 10MB
                // uploadSliceSize: 2147483648, // 2GB
                // uploadSliceSize: 10737418240, // 10GB
                uploadSessionCount: 10, // 업로드 세션 갯수
                addDuplicateFile: false,
                useDb: false, //클라이언트 DB사용여부
                showGraph: false,
                transferStart: { upload: 'auto', download: 'auto' }, //전송자동시작 유무
                // downloadType: "stream",
                monitorServer: '', //MRT URL
             	// Agent 설치 페이지
                installUrl: `${SDLUtil.WEB_CONTEXT_PATH}/static/js/innorix/install/install.html`,
                uploadUrl: upApiBase, // 업로드 URL
                downloadSessionCount: 10, // 다운로드 세션 갯수
                downloadType : "direct",
                downloadSliceSize: 10485760 // 10MB
            }

            // Tool Manager 사용여부
            if (!SDLUtil.isNull(this.toolManager)) {
                initCreateObject.uploadUrl = upApiBase + '?path=' + this.toolManager;
            }

            // Image Cloud 사용여부
            if (this.imageCloud) {
                initCreateObject.allowExtension = ['jpg', 'png', 'gif'];
                initCreateObject.maxFileCount= 1;
            }

            this.control = innorix.create(initCreateObject);
	          this.$emit("initialized");

            this.control.on('uploadComplete', (p) => {
                // alert("업로드가 완료 되었습니다.\n다운로드 가능하게 재구성 합니다.");
                this.$log.info('＃ InnorixUpload.vue uploadComplete => ', p);
                let fileArray = new Array(), f = p.files;
                // 업로드 완료된 파일을 다운로드 배열에 담기
                if(f.length > 0) {
                    for(let attach of f) {
                        let downloadUrl = downApiBase + "?attachFileSeq=" + attach.ENC_ATTCH_FILE_SEQ + "&encToken=" + attach.ENC_TOKEN;
                        if (this.isSCMSDirect) {
                            downloadUrl = downApiSCMS + "?attachFileSeq=" + attach.ENC_ATTCH_FILE_SEQ;
                        }
                        // this.$log.info('＃ InnorixDownload.vue AttachList download url => ', downloadUrl);
                        this.downFileArr.push({
                            attachFileSeq: attach.attachFileSeq,
                            printFileName: attach.clientFileName,
                            fileSize: attach.fileSize,
                            validate: true,
                            downloadUrl: downloadUrl
                        });
                    }

                    // TODO 아래 로직은 검증 필요, 각 파일 id 별로 postData 세팅
                    var fileInfo = this.control.getAllFiles();
                    for(let attach of f) {
                        let attachId = attach.id;
                        for (let i = 0; i < fileInfo.length; ++i) {
                            var postObj = new Object();
                            var fileId = fileInfo[i].id;
                            if(fileId === attachId) {
                                postObj._id = fileId;
                                postObj.attachFileSeq = attach.attachFileSeq;
                                this.control.setFilePostDataByIndex(i, postObj);
                            }
                        }
                    }
                };

                this.removeFlag = false;                                // 삭제 이벤트 발생시 동작을 방지
                this.control.removeAllFiles();                          // 리스트 컨트롤에서 파일을 삭제
                this.control.presetDownloadFiles(this.downFileArr);     // 다운로드 목록을 구성
            });

            // 파일전송 컨트롤 로딩 완료
            this.control.on('loadComplete', (p) => {
                // 세션정보 저장
                this.control.setCookie("JSESSIONID=" + this.sessionId);
                // 다운로드 목록
                this.downFileArr = this.setAttachList(this.attachList);
                this.resetFileArr = this.downFileArr;                   // 다운로드 정보 초기화 정보 생성
                this.resetFileArr = this.resetFileArr.slice(0);         // 배열 깊은 복사
                this.control.presetDownloadFiles(this.resetFileArr);    // 다운로드 파일 추가

                // 부모 컴포넌트로 데이터 전달
                this.emitParent();
            });

            // 업로드 파일이 추가됬을 때 이벤트
            this.control.on('afterAddFiles', (p) => {
                this.$log.info('＃ InnorixUpload.vue afterAddFiles => ', this.control.getUploadFiles());
                if (this.control.getUploadFiles().length > 0) {
                    // 컨트롤러에 파일 추가 시 이벤트 발생
                    this.control.setPostData({ token : this.token });
                    this.control.upload();
                };

                // 부모 컴포넌트로 데이터 전달
                this.emitParent();

                this.handleInnorixResize();
            });

            // 파일 업로드 시 에러 발생 (CustomError)
            this.control.on('uploadError', (p) => {
                this.$log.error('＃ InnorixUpload.vue file upload error => ', p);
                let fileState = p.files[0].fileState;
                let errMsg = p.files[0].errorTitle ? p.files[0].errorTitle : ( p.statusMessage.customError ? p.statusMessage.customError : SDLUtil.getMsgProp('MESSAGE.SYSTEM.APPLY.ERROR') );

                this.control.closeTransferWindow();
                SDLUtil.alert({
                    title: 'FIELD.GLOBAL.UPLOADING',
                    msg: errMsg,
                    okLabel: 'BUTTON.GLOBAL.CONFIRM'
                });

                // upload 리스트에서 삭제
                this.control.removeFileById(p.files[0].rowID);

                // 부모 컴포넌트로 데이터 전달
                this.emitParent();
            });

            // 파일 삭제 이벤트
            this.control.on('removeFiles', (p) => {
                if (this.removeFlag == true) {
                    // 삭제된 파일정보 배열에 담기
                        for (let i = 0; i < p.length; i++ ) {
                            this.$log.debug(p);
                            let fileObj = new Object();
                            if (p[i].transferType == "download") {
                                fileObj.attachFileSeq   = p[i].attachFileSeq;
                                fileObj.printFileName   = p[i].printFileName;
                                fileObj.fileSize        = p[i].fileSize;
                                this.delFileArr.push(fileObj);
                                this.deleteArr(this.downFileArr, "attachFileSeq", p[i].attachFileSeq);

                                if (this.serviceType !== 'common') this.deleteFileOnServer(fileObj.attachFileSeq);
                            }
                        }
                }
                this.removeFlag = true;
                this.$log.info('＃ InnorixUpload.vue delete files =>', this.delFileArr);
                // 부모 컴포넌트로 데이터 전달
                this.emitParent();
            });

            // 파일 더블클릭 이벤트
            this.control.on('onDblClickRows', (p) => {
                this.onDblClickRows();
            });

            this.isLoading = true;
        },

        deleteFileOnServer(attachFileSeq) {
            const params = { attachFileSeq };
            const path = `/basis/common/attachRemove.skp?${qs.stringify(params)}`;
            return axios.post(path);
        },

        // Basic button functions
        openFileDialog() {
            this.control.openFileDialog();
        },
        removeSelectedFiles() {
            if (this.serviceType !== 'common') {
                SDLUtil.confirm({
                    title: 'MESSAGE.ATTACH.DELETE.CONFIRM.TITLE',
                    msg: 'MESSAGE.ATTACH.DELETE.CONFIRM.MESSAGE',
                    okLabel: 'BUTTON.FAST.DELETE',
                    cancelLabel: 'BUTTON.GLOBAL.CANCEL',
                    onOkEvt: () => {
                        this.control.removeSelectedFiles();
                        // 부모 컴포넌트로 데이터 전달
                        this.emitParent();
                    },
                    onCancelEvt: () => {},
                });

            } else {
                this.control.removeSelectedFiles();
                // 부모 컴포넌트로 데이터 전달
                this.emitParent();

            }
        },
        removeAllFiles() {
            if (this.serviceType !== 'common') {
                SDLUtil.confirm({
                    title: 'MESSAGE.ATTACH.DELETE.CONFIRM.TITLE',
                    msg: 'MESSAGE.ATTACH.DELETE.CONFIRM.MESSAGE',
                    okLabel: 'BUTTON.FAST.DELETE',
                    cancelLabel: 'BUTTON.GLOBAL.CANCEL',
                    onOkEvt: () => {
                        this.control.removeAllFiles();
                        // 부모 컴포넌트로 데이터 전달
                        this.emitParent();
                    },
                    onCancelEvt: () => {},
                });

            } else {
                this.control.removeAllFiles();
                // 부모 컴포넌트로 데이터 전달
                this.emitParent();
            }
        },
        deleteArr(array, key, value) {
            for (let i = 0; i < array.length; i++) {
                if (array[i][key] == value) {
                    array.splice(i, 1);
                }
            }
        },
        reloadFileList(fileList) {
            this.downFileArr = this.setAttachList(fileList);
            this.control.presetDownloadFiles(this.downFileArr);     // 다운로드 목록을 구성
            // 부모 컴포넌트로 데이터 전달
            this.emitParent();
        },

        reset() {
            this.removeFlag = false;
            this.delFileArr = new Array(); // 삭제정보 초기화
            this.control.removeAllFiles(); // 리스트 컨트롤에서 파일을 삭제
            this.control.presetDownloadFiles(this.resetFileArr); // 다운로드 목록 초기화

            // 부모 컴포넌트로 데이터 전달
            this.emitParent();
        },
        // 부모창으로 파일 데이터 전달 (fileList, delFileList, isRemove)
        emitParent(e) {
            // TODO 필요한 데이터가 있을 경우 추가
            this.$emit('files', {
                uploadId: this.uploadId,
                fileList: this.getAllFiles,
                delFileList: this.delFileArr,
                isRemove: this.removeFlag
            });
        },
        // 다운로드 파일 리스트 설정
        setAttachList(attachList = []) {
            let downloadList = [];
            if(attachList.length > 0) {
                for(let attach of attachList) {
                    let downloadUrl = downApiBase + "?attachFileSeq=" + attach.ENC_ATTCH_FILE_SEQ + "&encToken=" + attach.ENC_TOKEN;
                    if (this.isSCMSDirect) {
                        downloadUrl = downApiSCMS + "?attachFileSeq=" + attach.ENC_ATTCH_FILE_SEQ;
                    }
                    // this.$log.info('＃ InnorixUnload.vue AttachList download url => ', downloadUrl);
                    // Vue.$log.info('SET ATTACH Download URL', downloadUrl);
                    downloadList.push({
                        attachFileSeq: attach.ATTCH_FILE_SEQ,
                        printFileName: attach.FILE_NM,
                        fileSize: attach.FILE_SIZE,
                        validate: true,
                        downloadUrl: downloadUrl /* + "," + attach.FILE_NM + "," + attach.FILE_SIZE*/
                    });
                }
            };
            Vue.$log.info('SET ATTACH Download URL', downloadList);
            return downloadList;
        },

        // 다운로드 이벤트
        downloadSelectedFiles() {
            this.control.downloadSelectedFiles();
        },
        onDblClickRows() {
            this.control.downloadSelectedFiles();
        },
        download() {
            this.control.download();
        },
    },
};
</script>

<style scoped>
    .innorix_basic { border: none; }
    .innorix_basic .irx_filetree_list .irx-file-inner-wrapper .btn-group {
        display: none !important;
    }
</style>



// WEBPACK FOOTER //
// src/skpComponents/common/InnorixUpload.vue